export default __webpack_public_path__ + "static/media/pending-action-icon.f61fd726.svg";